import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useApiState } from '../hooks/useApiState';
import './VerifyEmail.css';

function VerifyEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const { loading, error, setError, setLoading, executeRequest } = useApiState();
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Invalid or missing verification token');
      setLoading(false);
      return;
    }

    verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const verifyEmail = async () => {
    try {
      await executeRequest(() => authAPI.verifyEmail(token));
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      console.error('Verification error:', err);
    }
  };

  if (loading) {
    return (
      <div className="verify-email-container">
        <div className="verify-email-card">
          <div className="verify-email-header">
            <h1>Verifying Your Email</h1>
          </div>
          <div className="verify-email-loading">
            <div className="spinner"></div>
            <p>Please wait while we verify your email address...</p>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="verify-email-container">
        <div className="verify-email-card">
          <div className="verify-email-header success">
            <div className="success-icon">✓</div>
            <h1>Email Verified!</h1>
          </div>
          <div className="verify-email-success">
            <p>Your email has been successfully verified.</p>
            <p>You can now log in to your account.</p>
            <p className="redirect-message">Redirecting to login page...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className="verify-email-header">
          <h1>Verification Failed</h1>
        </div>
        <div className="verify-email-error">
          <p>{error}</p>
          <p>The verification link may have expired or is invalid.</p>
          <p>Please request a new verification email or contact support.</p>
        </div>
        <button onClick={() => navigate('/login')} className="btn btn-primary">
          Back to Login
        </button>
      </div>
    </div>
  );
}

export default VerifyEmail;
